import * as React from "react";

function FileCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m365.3 93.38-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.006 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6c0-16.9-6.7-33.2-18.7-45.22zM336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160V128c0 17.67 14.33 32 32 32h79.1v288zM166.7 324.7 136.1 295c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l48 48C155.5 381.5 161.7 384 168 384c.313 0 .625 0 .906-.031a23.989 23.989 0 0 0 17.31-8.344l96-112c8.625-10.06 7.47-25.22-2.594-33.84-10.03-8.594-25.19-7.47-33.84 2.594L166.7 324.7z"
  }));
}

const ForwardRef = React.forwardRef(FileCheckIcon);
export default ForwardRef;